import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import * as React from 'react';
import DesktopNavigation from './DesktopNavigation/DesktopNavigation';
import S from './Header.styles';
import MobileNavigation from './MobileNavigation/MobileNavigation';
const Header = ({ callUs, hideNavigation = false, navigation, translations, site, socialMediaLinks, logo }) => {
    const [menuOpen, setMenuOpen] = React.useState(false);
    const [hasScrolled, setHasScrolled] = React.useState(false);
    React.useEffect(() => {
        const handleScroll = () => {
            const position = window.scrollY;
            position > 0 ? setHasScrolled(true) : setHasScrolled(false);
        };
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (React.createElement(S.Container, { "data-shrink-header": hasScrolled },
        React.createElement(S.Inner, null,
            React.createElement(S.LogoWrapper, { href: site.url, target: "_self", "aria-label": site.label }, logo.src && React.createElement(S.LogoAlt, { src: logo.src, alt: logo.altText })),
            navigation && !hideNavigation && React.createElement(DesktopNavigation, { links: navigation }),
            React.createElement(S.InnerRight, null,
                React.createElement(S.CallUs, null,
                    React.createElement(S.CallUsLabel, null, callUs.label),
                    React.createElement(S.CallUsLink, { href: `tel:${callUs.number}`, target: "_blank" },
                        getSvgFromSystem(SystemIcon.Call),
                        React.createElement(S.CallUsNumber, null, callUs.number))),
                !hideNavigation && (React.createElement(S.MobileMenuToggle, { "aria-label": translations && translations['translations.global.menu.close'], title: translations && translations['translations.global.menu.close'], onClick: () => setMenuOpen(!menuOpen) }, menuOpen
                    ? getSvgFromSystem(SystemIcon.Close)
                    : getSvgFromSystem(SystemIcon.HamburgerMenu))))),
        navigation && !hideNavigation && (React.createElement(MobileNavigation, { links: navigation, open: menuOpen, socialMediaLinks: socialMediaLinks }))));
};
export default Header;
